export default __webpack_public_path__ + "static/Ruby-3494825407f8a73fe2c2e63063402ab9.webp";